import { memo, useEffect, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import styles from './LoadMoreSpinner.module.css';

export type LoadMoreSpinnerProps = {
  hasCursor: boolean;
  loadMoreItems: () => void;
};

export const LoadMoreSpinner = memo(
  ({ hasCursor, loadMoreItems }: LoadMoreSpinnerProps) => {
    const { t } = useTranslation();
    const loadMoreRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      const options = {
        root: null,
        rootMargin: '152px',
        threshold: 0,
      };

      const observer = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]) => {
          if (entries[0]?.isIntersecting && hasCursor) {
            loadMoreItems();
          }
        },
        options,
      );

      const currentRef = loadMoreRef.current;
      if (currentRef) {
        observer.observe(currentRef);
      }

      return () => {
        if (currentRef) {
          observer.unobserve(currentRef);
        }
      };
    }, [hasCursor, loadMoreItems]);

    return (
      <div
        ref={loadMoreRef}
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingBottom: '1rem',
        }}
      >
        <Spinner animation="border" role="status" style={{ color: '#05656B' }}>
          <span className="visually-hidden">{t('Loading...')}</span>
        </Spinner>
      </div>
    );
  },
);
